/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Analyse_CtaInputs */

const cs_ebr_analyse_cta = /** @type {(inputs: Ebr_Analyse_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Načíst a porovnat`)
};

const en_ebr_analyse_cta = /** @type {(inputs: Ebr_Analyse_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fetch and compare`)
};

/**
* | output |
* | --- |
* | "Fetch and compare" |
*
* @param {Ebr_Analyse_CtaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_analyse_cta = /** @type {((inputs?: Ebr_Analyse_CtaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Analyse_CtaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_analyse_cta(inputs)
	return cs_ebr_analyse_cta(inputs)
});